module.exports = __webpack_public_path__ + "img/fanyi.a32961ee.svg";